export default {
  id: null,
  nome: null,
  tpEventoId: null,
  deslocamento: false,
  despesa: false,
  inative: false,
  agendamento: false,
  contato: false,
  visita: false
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/eventmodel.js